<template>
  <div id="app">
    <div id="nav">
      <div class="desktop">
        <router-link to="/">Home</router-link>
        <router-link to="/wedding-day">Wedding</router-link>
        <router-link to="/meals">Meals</router-link>
        <p class="header"><router-link to="/">Nicole <span class="amp">&amp;</span> Jon</router-link></p>
        <router-link to="/rsvp">RSVP</router-link>
        <router-link to="/gifts">Gifts</router-link>
        <router-link to="/directions">Directions</router-link>
      </div>
      <div class="mobile">
        <p class="header"><router-link to="/">Nicole <span class="amp">&amp;</span> Jon</router-link></p>
        <div id="hamburger" class="hamburger" v-on:click="showMenu">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
        <div id="sidenav" class="sidenav">
          <router-link to="/">Home</router-link>
          <router-link to="/wedding-day">Wedding</router-link>
          <router-link to="/meals">Meals</router-link>
          <router-link to="/rsvp">RSVP</router-link>
          <router-link to="/gifts">Gifts</router-link>
          <router-link to="/directions">Directions</router-link>
          <a href="https://www.mass.gov/lists/covid-19-regulations-guidance" target="_blank">Covid</a>
        </div>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  el: '#hamburger',
  methods: {
    showMenu: function () {
      const hamburger = document.getElementById('hamburger')
      const sidenav = document.getElementById('sidenav')
      setTimeout(() => {
        hamburger.classList.toggle('change')
        if (sidenav.offsetWidth === 0) {
          sidenav.style.width = '250px'
        } else {
          sidenav.style.width = '0'
        }
      }, 500)
      window.addEventListener('click', (e) => {
        const el = e.target.classList.value
        if (!el.includes('hamburger') && !el.includes('bar1') && !el.includes('bar2') && !el.includes('bar3')) {
          setTimeout(() => {
            hamburger.classList.remove('change')
            sidenav.style.width = '0'
          }, 350)
        }
      })
    }
  }
}
</script>

<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #212529;

    #nav {
      padding: 0 20px;
      height: 80px;
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
      background-color: #191c21;

      .desktop {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .mobile {
        display: none;
      }

      .header {
        a {
          font-size: 2rem;
          padding: 0 30px;
          margin: 0;
          color: #FFF;
          text-decoration: none;
          text-transform: none;
          border-bottom: none;
          font-weight: 400;

          &.router-link-exact-active {
            border-bottom: none;
            color: #FFF;
          }
        }

        .amp {
          font-size: 1rem;
        }
      }

      a {
        font-weight: bold;
        color: #FFF;
        text-transform: uppercase;
        text-decoration: none;
        letter-spacing: 0.15rem;
        font-size: 0.875rem;
        margin: 0 20px;

        &.router-link-exact-active {
          border-bottom: 2px solid #AFBD8A;
          color: #AFBD8A;
        }
      }

      .hamburger {
        display: inline-block;
        cursor: pointer;
        z-index: 100;
      }

      .bar1, .bar2, .bar3 {
        width: 35px;
        height: 2px;
        background-color: #fff;
        margin: 6px 0;
        transition: 0.4s;
      }

      .change .bar1 {
        -webkit-transform: rotate(-45deg) translate(-4px, 3px);
        transform: rotate(-45deg) translate(-4px, 3px);
      }

      .change .bar2 {opacity: 0;}

      .change .bar3 {
        -webkit-transform: rotate(45deg) translate(-8px, -8px);
        transform: rotate(45deg) translate(-8px, -8px);
      }

      .sidenav {
        height: 100%;
        width: 0;
        position: fixed;
        z-index: 1;
        top: 0;
        right: 0;
        background-color: #191c21;
        overflow-x: hidden;
        transition: 0.5s;
        padding-top: 60px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        a {
          margin: 8px 8px 8px 32px;
          text-decoration: none;
          display: block;
          transition: 0.3s;
        }
      }
    }
  }

  @media only screen and (max-width: 944px){
    #app {
      #nav {
        .desktop {
          display: none;
        }

        .mobile {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .header {
          a {
            font-size: 1.5rem;
            padding: 0;
          }
        }
      }
    }
  }
</style>
